import * as moment from 'moment';

const defaultDateConvert = false;
const defaultDateFormat = 'DD MMM YYYY';
const defaultDateTimeConvert = true;
const defaultDateTimeFormat = 'DD MMM YYYY HH:mm';

function toView(value: any, convert: boolean, format: string) {
  if (value == null)
    return value;
  let m = moment.utc(value, moment.ISO_8601, true);
  if (!m.isValid())
    return value;
  if (convert)
    m = m.local();
  return m.format(format);
}

export class DateValueConverter {
  toView(value, convertOrFormat?: boolean | string, formatOrDefault = defaultDateFormat) {
    const convert = typeof convertOrFormat === 'boolean' ? convertOrFormat : defaultDateConvert;
    const format = typeof convertOrFormat === 'string' ? convertOrFormat : formatOrDefault;
    return toView(value, convert, format);
  }
}

export class DateTimeValueConverter {
  toView(value, convertOrFormat?: boolean | string, formatOrDefault = defaultDateTimeFormat) {
    const convert = typeof convertOrFormat === 'boolean' ? convertOrFormat : defaultDateTimeConvert;
    const format = typeof convertOrFormat === 'string' ? convertOrFormat : formatOrDefault;
    return toView(value, convert, format);
  }
}

export class DateInputValueConverter {
  toView = value => toView(value, false, moment.HTML5_FMT.DATE);
  fromView = value => moment.utc(value, moment.HTML5_FMT.DATE, true).toISOString();
}
